import { signatureConstants,configConstants } from '../_constants';
/**
 * signature
 *
 * @package                onboard
 * @subpackage             signature
 * @category               Reducers
 * @DateOfCreation         15 july 2019
 * @ShortDescription       This is responsible for all state related to User Signature
 */
//Initial State on load state and intial action with their type
const initialState = {
  isLoading: {
    businessAssignConsent: false
  },
  successMsg: false,
  errorMsg:false,
  isSignatureValid:false,
};
export function signature(state = initialState, action) {
  switch (action.type) {
    case signatureConstants.SIGNATURE_SUCCESS:
      return {
        ...state,
        successMsg : action.success
      };
    case signatureConstants.SIGNATURE_FAILURE:
      return {
        ...state,
        errorMsg : action.error
      };
    case signatureConstants.BUSINESS_ASSIGN_CONSENT_REQUEST:
        return { 
          ...state,
          isLoading: {
            ...state.isLoading,
            businessAssignConsent: true
          },
          successMsg: false,
          errorMsg: false
        };
    case signatureConstants.BUSINESS_ASSIGN_CONSENT_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          businessAssignConsent: false
        },
        successMsg : action.success,
        errorMsg: false
      };
    case signatureConstants.BUSINESS_ASSIGN_CONSENT_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          businessAssignConsent: false
        },
        errorMsg : action.error
      };
    case configConstants.UNAUTHENTICATE:
      return {
            ...state,
            isSignatureValid : true,
            errorMsg       : false
          };
    case signatureConstants.SIGNATURE_RESET:
      return {
                ...state,
                successMsg : false,
                errorMsg   : false,
             };
    default:
      return state
  }
}